import { Box } from "@mui/material"

export function FolderItemPart({ children, width = 32, ...props }) {
    return (
        <Box {...props} sx={{ ...props.sx, lineHeight: 0 }} width={width} flexGrow={0} flexShrink={1}>
            {children}
        </Box>
    )
}
